import { apiFetch } from './client'
import type { DraftResponse, SummaryResponse } from '../types'

/**
 * A tone id: one of the four built in, or one the org wrote ("org-1", …).
 * The backend resolves it — the panel only carries it back.
 */
export type Tone = string

export function requestDraft(ticketId: string, subject?: string, tone?: Tone, ask?: string) {
  return apiFetch<DraftResponse>('draftReply', { ticketId, subject, tone, ask })
}

/** Put the agent's own text on the ticket, as a private note or a real reply. */
export function postDraft(ticketId: string, content: string, as: 'note' | 'reply') {
  return apiFetch<{ ok: true; as: 'note' | 'reply'; to?: string }>('postDraft', {
    ticketId,
    content,
    as,
  })
}

export function requestSummary(ticketId: string) {
  return apiFetch<SummaryResponse>('summariseTicket', { ticketId })
}
